import { $api } from "../generated/client";
import type { GetAllGiftCodesResultDto } from "../generated/schema";

type UseGiftCodesQueryOptions = {
	shopId: string;
	pageSize?: number;
	initialCursor?: string;
};

export default function useGiftCodes({
	shopId,
	pageSize = 20,
	initialCursor,
}: UseGiftCodesQueryOptions) {
	return $api.useInfiniteQuery(
		"get",
		"/shops/{shopId}/gift-codes",
		{
			params: { path: { shopId }, query: { pageSize } },
		},
		{
			getNextPageParam: (lastPage: GetAllGiftCodesResultDto) =>
				lastPage.nextCursor,
			initialPageParam: initialCursor || undefined,
		},
	);
}
